import React from "react";

const Copyright = () => {
  return (
    <div className="container-fluid py-4" style={{ backgroundColor: '#000' }}>
      <div className="container">
        <div className="row">
          {/* Left Section */}
          <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
            <span className="text-light">
              <a href="https://everestmomocafe.vercel.app/" className="text-light">
                <i className="fas fa-copyright me-2"></i>
                Everest Momo Cafe
              </a>
              ,2024 All rights reserved.
            </span>
          </div>
          {/* Right Section */}
          <div className="col-md-6 text-center text-md-end text-white my-auto">
            {/* Attribution comment */}
            Designed By{" "}
            <a
              className="border-bottom text-light"
              href="https://merodigit.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mero Digit
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Copyright;
